import { Component } from '@angular/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import * as moment from 'moment';
import { DataServiceProvider } from '../../providers/data-service/data-service';

@Component({
  selector: 'diaper-modal',
  templateUrl: 'diaper-modal.html'
})
export class DiaperModalComponent {
  user: any;
  newEntry: boolean = true;
  diaper: any = {
    pee: true,
    poop: false,
    comment: '',
    timestamp: moment().format(),
    uid: ''
  };

  constructor(
    public viewCtrl: ViewController,
    public toastCtrl: ToastController,
    public navParams: NavParams,
    private dataService: DataServiceProvider
  ) {
    if (navParams.data.diaper) {
      this.diaper = navParams.data.diaper;
      this.newEntry = false;
    }
  }

  submit() {
    this.user = this.dataService.user;
    if (this.user) {
      if (!this.newEntry) {
        this.dataService.data
          .child(this.user.uid)
          .child('diapers')
          .child(this.diaper.uid)
          .remove();
      }
      this.diaper.userId = this.user.uid;
      let key = this.dataService.data
        .child(this.user.uid)
        .child('diapers')
        .push().key;
      this.diaper.uid = key;
      this.dataService.data
        .child(this.user.uid)
        .child('diapers')
        .child(key)
        .set(this.diaper);

      let toast = this.toastCtrl.create({
        message: 'Wickelung erfolgreich gespeichert',
        duration: 3000,
        position: 'top'
      });
      toast.present().then((value: any) => {
        this.viewCtrl.dismiss();
      });
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/diaper-modal/diaper-modal.ts